<script setup>
import BarIconDisable from "@/components/icons/BarIconDisable.vue";
import BarIconEdit from "@/components/icons/BarIconEdit.vue";
import BarIconExport from "@/components/icons/BarIconExport.vue";
import BarIconArchive from "@/components/icons/BarIconArchive.vue";
import BarIconDelete from "@/components/icons/BarIconDelete.vue";
import BarIconCheck from "@/components/icons/BarIconCheck.vue";

import {defineProps, defineEmits} from "vue";

defineProps({
  selectedCount: {
    type: Number,
    required: true,
    default: 0,
  }
});

const emit = defineEmits(["reset-selection", "update-rows", "delete-rows", "open-tag-editor"]);
</script>

<template>
  <div class="table-bar">
    <div
      class="table-bar__item"
      @click="emit('update-rows', 'disable')"
    >
      <BarIconDisable />
      Выключить
    </div>
    <div @click="emit('open-tag-editor')" class="table-bar__item">
      <BarIconEdit />
      Редактировать теги
    </div>
    <div
      style="cursor: not-allowed"
      class="table-bar__item"
    >
      <BarIconExport />
      Экспорт
    </div>
    <div
      class="table-bar__item"
      @click="emit('update-rows', 'archive')"
    >
      <BarIconArchive />
      В архив
    </div>
    <div @click="emit('delete-rows')" class="table-bar__item">
      <BarIconDelete />
      Удалить
    </div>
    <div
      class="table-bar__item"
      @click="emit('reset-selection')"
    >
      Выбрано {{ selectedCount }}
      <BarIconCheck />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.table-bar {
  background: transparent;
  bottom: 10%;
  display: flex;
  gap: 2px;
  left: 50%;
  position: fixed;
  transform: translateX(-50%);
  z-index: 10;

  &__item {
    align-items: center;
    background: #1A64D4;
    color: #F7F8FD;
    cursor: pointer;
    display: flex;
    font-size: 14px;
    font-weight: 500;
    gap: 6px;
    height: 42px;
    padding: 6px 15px;
    user-select: none;
    &:first-child {
      border-bottom-left-radius: 8px;
      border-top-left-radius: 8px;
    }
    &:last-child {
      border-bottom-right-radius: 8px;
      border-top-right-radius: 8px;
    }
    &:hover {
      background: #1658BC;
    }
  }
}
</style>